<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.ivu-mr,
.ivu-mr-16 {
  margin-right: 16px !important;
}
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}
.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}
.flexs {
  display: flex !important;
  width: 20%;
}
//  需要改某一个 样式    equipment 下面的 子 el-form-item__label
.equipment .el-form-item__label {
  line-height: 22px;
}
</style>

<template>
  <el-card
    shadow="never"
    class="l-main-card"
    v-loading="loading_export"
    element-loading-text="拼命导出中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
  
    <div class="l-table-place">
      <!-- <div class="flex items-center justify-between ivu-mt">
        <div class="flex items-center">
          <p>场所类型：</p>
          <el-row>
            <el-button
              type="info"
              :class="{active:search_data.type==''?true:false}"
              plain
              @click="placetype(1)"
              v-model="search_data.type"
            >全部</el-button>
            <el-button
              type="info"
              :class="{active:search_data.type==item.id?true:false}"
              plain
              v-for="item in place_type_list"
              :key="item.id"
              @click="placetype(item.id)"
              v-model="search_data.type"
              v-show="item.id!=1"
            >{{item.name}}</el-button>
          </el-row>
          <el-row style="text-align:right; flex:1;">
            <l-auth-button
              class="ivu-mr"
              type="info"
              auth="place_import_btn"
              @click="import_visible=true"
              :loading="import_loading"
            >导入</l-auth-button>
            <el-dropdown class="ivu-mr" @command="command">
              <el-button type="info">
                <i class="el-icon-arrow-down el-icon--right"></i> 批量导出台账(excel)
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click="placeAccount()" :command="1">
                  <l-auth-text-button auth="place_export_btn">纯数字台账</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="2">
                  <l-auth-text-button auth="hiden_danger_export_btn">隐患未合并台账</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="3">
                  <l-auth-text-button auth="hiden_danger_whole_export_btn">隐患合并在一个单元格</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="4">
                  <l-auth-text-button auth="place_export_btn_4">监理核查错，漏排清单</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="5">
                  <l-auth-text-button auth="place_export_btn_5">监理核查错，漏排隐患数统计</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="6">
                  <l-auth-text-button auth="place_export_btn_6">三小场所各社区的A,B,C,D隐患分布</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="7">
                  <l-auth-text-button auth="place_export_btn_7">出租房各社区的A,B,C,D隐患分布</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="8">
                  <l-auth-text-button auth="place_export_btn_8">公共场所各社区的A,B,C,D隐患分布</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="9">
                  <l-auth-text-button auth="place_export_btn_9">工业企业各社区的A,B,C,D隐患分布</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="10">
                  <l-auth-text-button auth="place_export_btn_10">牵头部门A,B,C,D级责任人隐患追踪表</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="11">
                  <l-auth-text-button auth="place_export_btn_11">三小场所排查隐患库</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="12">
                  <l-auth-text-button auth="place_export_btn_12">出租房检查标准库</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="13">
                  <l-auth-text-button auth="place_export_btn_13">公共场所检查标准库</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="14">
                  <l-auth-text-button auth="place_export_btn_14">工业企业检查标准库</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="15">
                  <l-auth-text-button auth="place_export_btn_15">综合检查标准库</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="16">
                  <l-auth-text-button auth="place_export_btn_16">住宅小区检查标准库</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="17">
                  <l-auth-text-button auth="place_export_btn_17">督导预审明细</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="18">
                  <l-auth-text-button auth="place_export_btn_18">督导整改明细</l-auth-text-button>
                </el-dropdown-item>
                <el-dropdown-item :command="19">
                  <l-auth-text-button auth="place_export_btn_19">每日工作统计</l-auth-text-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <l-auth-button
              class
              type="info"
              auth="place_batch_report_btn"
              @click="placeAccount_s('placeExport_batchReport')"
              :loading="export_loading_s"
            >批量导出整改意见书</l-auth-button>
            <l-auth-button
              class
              type="info"
              auth="place_batch_rectifyreport_btn"
              @click="placeAccount_s('placeExport_batchRectifyReport')"
              :loading="export_loading_s"
            >批量导出整改告知书</l-auth-button>
            <l-auth-button
              class
              type="info"
              auth="place_batch_reviewreport_btn"
              @click="placeAccount_s('placeExport_batchReviewReport')"
              :loading="export_loading_s"
            >批量导出复查报告(word)</l-auth-button>
          </el-row>
        </div>
      </div> -->

      <div class="flex flex-warp">
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所名称</p>
          <el-input
            placeholder="请输入场所名称"
            v-model="search_data.name"
            class="input-with-select"
            style="width: 76%;"
          >
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所地址</p>
          <el-input
            placeholder="请输入场所地址"
            v-model="search_data.network"
            class="input-with-select"
            style="width: 76%;"
          >
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">联系人</p>
          <el-input
            placeholder="请输入联系人"
            v-model="search_data.legacy_name"
            class="input-with-select"
            style="width: 76%;"
          >
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">负责人</p>
          <el-input
            placeholder="请输入负责人"
            v-model="search_data.charge"
            class="input-with-select"
            style="width: 76%;"
          >
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属街道</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.street_id" placeholder="全部" clearable @change="changes">
              <el-option
                v-for="item in street_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所状态</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.management_state" placeholder="全部" clearable  @change="changes">
              <el-option 
                v-for="item in MANAGEMENT"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属社区</p>
          <div class="l-show-more-search">
            <el-select
              v-model="search_data.community_id"
              placeholder="全部"
              clearable
              @change="changes"
            >
              <el-option
                v-for="item in community_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">经营状态</p>
            <el-select v-model="search_data.management_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in MANAGEMENT" :key="index" :label="item" :value="index"  @change="changes"> </el-option>
            </el-select>
        </div>-->

        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">设备安装状态</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.community_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in community_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>-->

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">排查日期</p>
          <div class="l-show-more-search" style="width: 76%;">
            <el-date-picker
              v-model="value2_check"
              type="datetimerange"
              @blur="onPick_check(false)"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="onPick_check(false)"
            ></el-date-picker>
            <!-- <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
            </el-date-picker>-->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="l-primary l-table-config" style=" border-bottom: solid 1px #e4e7ed;">
      <el-popover
        placement="bottom-start"
        width="200"
        trigger="click"
        popper-class="l-table-column-fixed-select-box"
      >
        <span slot="reference">
          <i class="el-icon-setting"></i>表格列表配置
        </span>
        <div class>
          <div class="l-flex l-flex-just-between" style="margin-bottom:10px">
            <div>
              表格列表配置
              <i
                class="el-icon-refresh-left"
                style="float:right;  color: red;margin: 3px;"
                @click="resetFixedCheck"
              >重置</i>
            </div>
          </div>
          <el-divider class="l-table-column-fixed-title-divider"></el-divider>
          <el-checkbox-group v-model="fixed_list">row
            <div v-for="(item,index) in columns" :key="index">
              <el-checkbox :label="item.prop" style="margin-bottom:4px">{{item.label}}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </el-popover>

      <div style="float: right;" @click="search_visible = true">
        <span>
          <i class="el-icon-search"></i>
          高級搜索
        </span>
      </div>
    </div> -->
    
    <l-page
      :total="count"
      @current-change="getList"
      @size-change="getList"
      :page-size.sync="page_size"
      :current-page.sync="page"
    ></l-page>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        v-bind="{ ...item }"
        :label="item.label"
        show-overflow-tooltip
      >
        <template v-slot="{ row }">
          <template v-if="item.prop == 'owner_state'">{{ OWNER[row.owner_state] }}</template>
          <template v-else-if="item.prop == 'sign_for_state'">{{ OWNER[row.sign_for_state] }}</template>
          <template v-else-if="item.prop == 'state'">
            <el-tag type="success" disable-transitions>{{ MANAGEMENTLIST[row.state] }}</el-tag>
          </template>
          <template v-else-if="item.prop == 'adopt_state'">{{ ADOPT_STATE[row.adopt_state] }}</template>
          <template v-else>{{ row[item.prop] }}</template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="300" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="site_info_btn" @click="showInfo(row.id)">
            <i class="el-icon-edit"></i>详情
          </l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="site_edit_btn" @click="showEdit(row.id)">
            <i class="el-icon-edit"></i>编辑
          </l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="site_del_btn" @click="del(row.id)">
            <i class="el-icon-delete"></i>删除
          </l-auth-text-button>
          <!-- <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="place_download_btn" @click="download(row.id)">
            <i class="el-icon-download"></i>下载场所整改意见书
          </l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="place_download_rectify_btn" @click="download_rectify(row.id)">
            <i class="el-icon-download"></i>下载整改告知书
          </l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="place_download_supervise_btn" @click="download_supervise(row.id)">
            <i class="el-icon-download"></i>下载督导意见书
          </l-auth-text-button> -->
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page
      :total="count"
      @current-change="getList"
      @size-change="getList"
      :page-size.sync="page_size"
      :current-page.sync="page"
    ></l-page>
    <!--高级搜索-->
    <el-drawer
      title="更多搜索"
      class="l-search-drawer"
      :modal="false"
      :visible.sync="search_visible"
      size="400px"
      :append-to-body="false"
      :modal-append-to-body="false"
      z-indx="-1"
    >
      <div class="l-search-drawer-body">
        <el-form label-width="80px" ref="search_form" :model="search_data">
          <el-form-item label="场所ID" prop="id">
            <el-input v-model="search_data.id" placeholder="请输入场所ID"></el-input>
          </el-form-item>
          <el-form-item label="场所名称" prop="name">
            <el-input v-model="search_data.name" placeholder="请输入场所名称"></el-input>
          </el-form-item>
          <el-form-item label="网格名称" prop="network">
            <el-input v-model="search_data.network" placeholder="请输入网格名称"></el-input>
          </el-form-item>
          <el-form-item label="隐患描述" prop="legacy_name">
            <el-input v-model="search_data.legacy_name" placeholder="请输入隐患描述"></el-input>
          </el-form-item>

          <el-form-item label="负责人" prop="charge">
            <el-input v-model="search_data.charge" placeholder="请输入负责人"></el-input>
          </el-form-item>

          <el-form-item label="所属街道" prop="street_name">
            <el-select v-model="search_data.street_id" placeholder="全部" clearable>
              <el-option
                v-for="item in street_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属社区" prop="community_name">
            <el-select v-model="search_data.community_id" placeholder="全部" clearable>
              <el-option
                v-for="item in community_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="行业筛选" prop="industry_name">
            <el-select v-model="search_data.industry_id" placeholder="全部" clearable>
              <el-option
                v-for="item in industry_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备安装状态" class="equipment" prop="equipment_state">
            <el-select v-model="search_data.equipment_state" placeholder="全部" clearable>
              <el-option
                v-for="(item, index) in CURRENCY_STATE"
                :key="index"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排查状态" prop="check_state">
            <el-select v-model="search_data.check_state" placeholder="全部" clearable>
              <el-option
                v-for="(item, index) in CURRENCY_STATE"
                :key="index"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="督导状态" prop="supervision_state">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable>
              <el-option
                v-for="(item, index) in SUPERVISION"
                :key="index"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="经营状态" prop="management_state">
            <el-select v-model="search_data.management_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in MANAGEMENT" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>-->

          <el-form-item label="只看隐患场所" class="equipment" prop="hidden_state">
            <el-switch
              v-model="search_data.hidden_state"
              :active-value="2"
              :inactive-value="1"
              active-text="查看状态"
            ></el-switch>
          </el-form-item>

          <el-form-item label="业主签名" prop="owner_state">
            <el-select v-model="search_data.owner_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in OWNER" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="签收照片" prop="sign_for_state">
            <el-select v-model="search_data.sign_for_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in OWNER" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="复查照片" prop="review_state">
            <el-select v-model="search_data.review_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in OWNER" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="添加时间" prop="value2">
            <div class="l-show-more-search" style="width: 76%;">
              <el-date-picker
                v-model="value2"
                type="daterange"
                autocomplete="off"
                @blur="onPick(false)"
                clearable
                value-format="yyyy-MM-dd"
                start-placeholder="请选择有效起始时间"
                end-placeholder="请选择有效结束时间"
                @change="onPick(false)"
              ></el-date-picker>
            </div>
          </el-form-item>
          <!-- <el-form-item label="排查时间筛选" prop="value2_check">
            <div class="l-show-more-search" style="width: 76%;">
              <el-date-picker v-model="value2_check" type="daterange" autocomplete="off" @blur="onPick_check(false)" clearable value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick_check(false)">
              </el-date-picker>
            </div>
          </el-form-item>-->

          <el-form-item label="排序方式" prop="sort_state">
            <el-select v-model="search_data.sort_state" placeholder="全部" clearable>
              <el-option
                v-for="(item, index) in SORT_ORDER"
                :key="index"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="正序倒序" prop="sort">
            <el-select v-model="search_data.sort" placeholder="全部" clearable>
              <el-option v-for="(item, index) in SORT" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div class="l-search-drawer-footer">
        <el-button type="normal" @click="onReset">重置</el-button>
        <el-button type="primary" @click="onSearch">搜索</el-button>
      </div>
    </el-drawer>

    <!--详情-->
    <l-dialog :visible.sync="edit_visible" title="修改场所信息" width="1600px">
      <l-place-edit :visible.sync="edit_visible" :id="edit_id" @on-success="onEditSucess" />
    </l-dialog>

    <!--bianji-->
    <l-dialog :visible.sync="info_visible" title="场所信息" width="1600px">
      <l-place-info :visible.sync="info_visible" :id="info_id" is-info />
    </l-dialog>

    <!--导入-->
    <l-dialog :visible.sync="import_visible" title="导入" width="800px">
      <l-place-import @on-success="onImportSuccess" :visible.sync="import_visible" />
    </l-dialog>
  </el-card>
</template>
<script>
import {
  METHOD_NAMES,
  STATE_NAMES,
  TYPE_NAMES,
  IS_PUBLIC_NAMES
} from "@/common/constants/resources";
import {
  SUPERVISION,
  OWNER,
  STATES,
  CURRENCY_STATE,
  MANAGEMENTLIST,
  // MANAGEMENT,
  SORT_ORDER,
  SORT,
  ADOPT_STATE
} from "@/common/constants/place";
// import { dateToStr,time_pick2 } from "@/utils/Fuc";
import Info from "./Info";
import Edit from "./Edit";
import Import from "./Import.vue";
import Vue from "vue";
export default {
  components: {
    [Info.name]: Info,
    [Edit.name]: Edit,
    [Import.name]: Import
  },
  data() {
    return {
      value1: "",
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      info_visible: false, //是否显示编辑
      edit_visible: false, //是否显示编辑
      import_visible: false, //是否显示导入
      edit_id: 0,
      info_id: 0,
      place_type_list: [],
      community_list: [],
      street_list: [],
      industry_list: [{ id: 1, name: "行业" }],
      TYPE_NAMES: TYPE_NAMES,
      METHOD_NAMES: METHOD_NAMES,
      IS_PUBLIC_NAMES: IS_PUBLIC_NAMES,
      STATE_NAMES: STATE_NAMES,

      CURRENCY_STATE: CURRENCY_STATE,
      STATES: STATES,
      SUPERVISION: SUPERVISION,
      OWNER: OWNER,
      SORT_ORDER: SORT_ORDER,
      SORT: SORT,
      MANAGEMENTLIST:MANAGEMENTLIST,
      // 状态
      MANAGEMENT: [],

      ADOPT_STATE: ADOPT_STATE,

      //搜索
      search_visible: false,
      search_data: {
        id: "",
        name: "",
        charge: "",
        network: "",
        legacy_name: "",
        place_type_id: "",
        community_id: "",
        street_id: "",
        hidden_state: "1",
        equipment_state: "",
        industry_id: "",
        check_state: "",
        supervision_state: "",
        management_state: "",
        owner_state: "",
        sign_for_state: "",
        review_state: "",
        start_time: "",
        end_time: "",
        check_start_time: "",
        check_end_time: "",
        sort_state: "1",
        sort: "1",
        type: ""
      },
      ids: [],
      rel_search_data: {},
      show_more_search: false,
      value2: "",
      value2_check: "",
      loading_export: false,
      export_loading: false,
      export_loading_s: false,
      import_loading: false,
      //默认
      re_fixed_list: [
        "index",
        "id",
        "community_name",
        "place_sn",
        "name",
        "doorplate_address",
        "hidden_danger_n"
      ],
      fixed_list: [
        "index",
        "id",
        "community_name",
        "place_sn",
        "name",
        "doorplate_address",
        "hidden_danger_n"
      ]
    };
  },
  computed: {
    columns() {
      let columns = [
        {
          prop: "index",
          label: "序号",
          fixed: true,
          width: "60"
        },
        {
          prop: "street_name",
          label: "所属街道",
          fixed: true,
          width: "100"
        },
        {
          prop: "community_name",
          label: "所属社区",
          fixed: true,
          Width: "100"
        },
        {
          prop: "department_name",
          label: "所属部门",
          fixed: true,
          Width: "100"
        },
        {
          prop: "name",
          label: "场所名称",
          fixed: true,
          Width: "120"
        },
        {
          prop: "site_code",
          label: "场所编码",
          fixed: true,
          Width: "120"
        },
        {
          prop: "abbreviation",
          label: "场所名称缩写",
          fixed: true,
          Width: "120"
        },
        {
          prop: "site_address",
          label: "场所地址",
          fixed: true,
          width: "120"
        },
        {
          prop: "site_charger",
          label: "场所负责人",
          fixed: true,
          width: "100"
        },
        {
          prop: "site_charger_tel",
          label: "负责人电话",
          fixed: true,
          width: "100"
        },
        {
          prop: "site_contact",
          label: "场所联系人",
          fixed: true,
          width: "100"
        },
        {
          prop: "site_contact_tel",
          label: "联系人电话",
          fixed: true,
          width: "100"
        },
        {
          prop: "moduler_name",
          label: "所属模块",
          fixed: true,
          width: "100"
        },
        {
          prop: "state_name",
          label: "状态",
          fixed: true,
          width: "100"
        },
        
      ];

      let result = columns.map(item => {
        const index = this.fixed_list.findIndex(itm => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    }
  },

  watch: {
    fixed_list(val) {
      if (val.length > 20) {
        this.fixed_list.shift();
      }
    }
  },

  mounted() {
    this.getList();
    this.getSearchData();
  },

  methods: {
    command(e) {
      switch (e) {
        case 1: //台账
          this.placeAccount("place_accountExport");
          break;
        case 2: //隐患明细
          this.placeAccount("place_dangerDetailsExport");
          break;
        case 3: //隐患明细(合并)
          this.placeAccount("placeExport_getHiddenDetails");
          break;
        case 4: //监理核查错，漏排清单
          this.placeAccount("placeExport_superviseCheck");
          break;
        case 5: //监理核查错，漏排隐患数统计   先写其他的
          this.placeAccount("placeExport_superviseCheck");
          break;
        case 6: //三小场所各社区的ABCD隐患分布
          this.placeAccount("placeExport_export6");
          break;
        case 7: //出租房各社区的ABCD隐患分布
          this.placeAccount("placeExport_export7");
          break;
        case 8: //公共场所各社区的ABCD隐患分布
          this.placeAccount("placeExport_export8");
          break;
        case 9: //工业企业各社区的A,B,C,D隐患分布
          this.placeAccount("placeExport_export9");
          break;
        case 10: //牵头部门A,B,C,D级责任人隐患追踪表
          this.placeAccount("placeExport_export10");
          break;
        case 11: //三小场所检查标准库
          this.placeAccount("placeExport_export11");
          break;
        case 12: //出租房检查标准库
          this.placeAccount("placeExport_export12");
          break;
        case 13: //公共场所检查标准库
          this.placeAccount("placeExport_export13");
          break;
        case 14: //工业企业检查标准库
          this.placeAccount("placeExport_export14");
          break;
        case 15: //综合检查标准库
          this.placeAccount("placeExport_export15");
          break;
        case 16: //住宅小区检查标准库
          this.placeAccount("placeExport_export16");
          break;
        case 17: //督导预审明细
          this.placeAccount("placeExport_export17");
          break;
        case 18: //督导整改明细
          this.placeAccount("placeExport_export18");
          break;
        case 19: //每日工作统计
          this.placeAccount("placeExport_export19");
          break;
      }
    },

    //导出
    placeAccount(url) {
      this.rel_search_data = this.search_data;
      this.loading_export = true;
      this.$_invoke(url, {
        type: this.search_data.type,
        ...this.rel_search_data
      })
        .then(ret => {
          window.open(ret);
        })
        .finally(() => {
          this.loading_export = false;
        });
    },
    // //导出
    // placeAccount(url) {
    //   this.export_loading = true;
    //   this.$_invoke(url, { type:this.search_data.type,...this.rel_search_data})
    //     .then((ret) => {
    //       window.open(ret);
    //     })
    //     .finally(() => {
    //       this.export_loading = false;
    //     });
    // },

    //导出
    placeAccount_s(url) {
      this.export_loading_s = true;
      //进行 循环 拿出id
      for (let itme of this.data) {
        // // console.log(itme.id);
        this.ids.push(itme.id);
      }
      // console.log(this.ids);
      this.$_invoke(url, {
        type: this.search_data.type,
        ...this.rel_search_data,
        ids: this.ids
      })
        .then(ret => {
          this.ids = [];
          window.open(ret);
        })
        .finally(() => {
          this.export_loading_s = false;
        });
    },

    // 下载场所整改意见书
    download(id) {
      this.export_loading = true;
      this.$_invoke("place_download", { place_id: id })
        .then(ret => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
    },

    // 下载整改告知书
    download_rectify(id) {
      this.export_loading = true;
      this.$_invoke("place_download_rectify", { place_id: id })
        .then(ret => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
    },

    // 下载督导意见书
    download_supervise(id) {
      this.export_loading = true;
      this.$_invoke("place_download_supervise", { place_id: id })
        .then(ret => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
    },

    //通过类型筛选
    placetype(id) {
      this.search_data.type = id;
      this.search_data.management_state = ""; 
      this.rel_search_data = this.search_data;
      this.getSearchData();
      this.getList();
    },
    changes() {
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("site_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data
      })
        .then(ret => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取搜索信息

    getSearchData() {
      this.loading = true;
      this.$_invoke("site_getSearchData", {
        type: this.search_data.type
      })
        .then(ret => {
          this.street_list = ret.street_list;
          this.community_list = ret.community_list;
          this.place_type_list = ret.place_type_list;
          this.MANAGEMENT = ret.place_state_list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //显示详情
    showInfo(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },
    //删除
    del(id) {
      this.$confirm("确定删除整个场所信息吗？场所里的所有物资及检查记录也会一并删除，请慎重选择！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$_invoke(`site_del`, { place_id: id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    //默认时间
    // onfocus() {
    //   if (this.value2 == "" || !this.value2) {
    //     this.value2 = time_pick2();
    //   }
    // },
    //时间搜索
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2[0];
        this.search_data.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },

    onPick_check(cant) {
      if (!this.value2_check) {
        this.value2_check = "";
        this.search_data.check_start_time = "";
        this.search_data.check_end_time = "";
      } else {
        this.search_data.check_start_time = this.value2_check[0];
        this.search_data.check_end_time = this.value2_check[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },

    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
    //显示导入
    onImportSuccess() {
      this.import_visible = false;
      this.getList();
    }
  }
};
</script>
